import { useState } from 'react';
import { Routes, Route } from 'react-router-dom';

// Hooks
import { useCursor }           from './hooks/useCursor';
import { useScrollReveal }     from './hooks/useScrollReveal';
import { useCounterAnimation } from './hooks/useCounterAnimation';

// Components
import Navbar         from './components/Navbar/Navbar';
import Hero           from './components/Hero/Hero';
import LogoStrip      from './components/LogoStrip/LogoStrip';
import DoctorSection  from './components/DoctorSection/DoctorSection';
import Expertise      from './components/Expertise/Expertise';
import AdvisorSection from './components/AdvisorSection/AdvisorSection';
import Testimonials   from './components/Testimonials/Testimonials';
import Books          from './components/Books/Books';
import Modal          from './components/Modal/Modal';
import Footer         from './components/Footer/Footer';
import ServiceDetail  from './components/ServiceDetail/ServiceDetail';

function App() {
  const [modalOpen, setModalOpen] = useState(false);

  // Custom hooks
  const { curRef, curRRef } = useCursor();
  useScrollReveal();
  useCounterAnimation();

  const openModal  = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const HomePage = () => (
    <>
      <Hero           onOpenModal={openModal} />
      <LogoStrip />
      <Expertise onOpenModal={openModal} />
      <DoctorSection  onOpenModal={openModal} />
      <AdvisorSection onOpenModal={openModal} />
      <Testimonials />
      <Books          onOpenModal={openModal} />
      <Footer />
    </>
  );

  return (
    <>
      {/* Custom cursor elements */}
      <div id="cur"   ref={curRef} />
      <div id="cur-r" ref={curRRef} />

      <Navbar onOpenModal={openModal} />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services/:slug" element={<ServiceDetail onOpenModal={openModal} />} />
      </Routes>

      {/* Phone FAB */}
      <a href="tel:+1234567890" className="wa" title="Call Now">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="white">
          <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
        </svg>
      </a>

      {/* Lead modal */}
      <Modal isOpen={modalOpen} onClose={closeModal} />
    </>
  );
}

export default App;
